import { css, cx } from 'emotion';
import {
	headingSmallLight,
	textBlock,
	darkGrey,
	mobileMaxWidthBreakpoint,
} from 'inside-out/global-styles';
import LocationIcon from 'inside-out/images/location-icon.svg';

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const wrapperStyle = background =>
	css({
		padding: background ? '190px 0 0' : '0',
		position: 'relative',
		zIndex: '1',
		...(background
			? {
				'&:after': {
					borderRadius: '6px',
					content: "' '",
					display: 'block',
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '190px',
					background: `url(${background}) no-repeat top center`,
					backgroundSize: 'cover',
				},
			}
			: null),
		'&:hover': {
			[`& .${titleStyle}`]: {
				textDecoration: 'underline',
			},
		},
	});

export const titleStyle = cx(
	headingSmallLight,
	css({
		margin: '12px 0',
	})
);

export const bodyStyle = cx(
	textBlock,
	css({
		marginTop: 0,
		marginBottom: '10px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			display: 'none',
		},
	})
);

const metaStyle = {
	fontSize: '12px',
	lineHeight: '18px',
	margin: '10px 0 0',
	textAlign: 'left',
};

export const metaDateStyle = css({
	...metaStyle,
	color: '#8A8B8C'
});

export const metaLocationStyle = css({
	...metaStyle,
	color: darkGrey,
	fontWeight: 500,
	paddingLeft: '28px',
	background: `transparent url(${LocationIcon}) no-repeat left center`,
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/carouselCard/styles.js